import type { CurrencyFormatterOptions } from 'hooks/useNumberFormatters'
import { useCurrencyFormatter } from 'hooks/useNumberFormatters'
import type { CurrencyFormat } from 'lib/format/formatCurrencyIntl'
import { memo } from 'react'

interface Props extends CurrencyFormatterOptions {
  value: number
  countryCode?: string
  format?: CurrencyFormat

}

function FormatCurrency({ value, format, ...rest }: Props) {
  const formatter = useCurrencyFormatter(rest)
  const formatted = formatter(value, format)

  return <>{formatted}</>
}

export default memo(FormatCurrency)
